import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { statementOfFaith } from '../../data/mock';
import { ArrowLeft, Heart, Cross, BookOpen, Sparkles, Users, Star } from 'lucide-react';
import { Button } from '../ui/button';

const iconMap = {
  0: Cross,
  1: BookOpen,
  2: Heart,
  3: Sparkles,
  4: Star,
  5: Users
};

const FaithPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-white to-coral-50">
      <Header />
      
      <main className="pt-24 pb-16">
        {/* Hero Section */}
        <section className="relative py-16 overflow-hidden">
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-10 left-20 w-32 h-32 bg-amber-200 rounded-full blur-3xl" />
            <div className="absolute bottom-10 right-10 w-40 h-40 bg-coral-200 rounded-full blur-3xl" />
          </div>
          
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            <Link to="/" className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 mb-8 group">
              <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
              Back to Home
            </Link>
            
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-amber-100 rounded-2xl">
                <Heart className="w-8 h-8 text-amber-600" />
              </div>
              <h1 className="text-4xl sm:text-5xl font-serif font-bold text-slate-800">
                Statement of Faith
              </h1>
            </div>
            
            <p className="text-xl text-slate-600 leading-relaxed">
              The foundational beliefs that guide our ministry and shape our resources.
            </p>
          </div>
        </section>

        {/* Statement of Faith Cards */}
        <section className="py-12">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-6">
              {statementOfFaith.map((item, index) => {
                const Icon = iconMap[index] || Heart;
                return (
                  <div
                    key={item.id}
                    className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-slate-100 hover:shadow-xl transition-shadow group"
                  >
                    <div className="flex gap-4 sm:gap-6">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 bg-gradient-to-br from-amber-100 to-coral-100 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform">
                          <Icon className="w-6 h-6 text-amber-600" />
                        </div>
                      </div>
                      <div>
                        <h3 className="text-xl font-serif font-bold text-slate-800 mb-3">
                          {item.title}
                        </h3>
                        <p className="text-slate-600 leading-relaxed">
                          {item.content}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Scripture Quote */}
        <section className="py-12">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-3xl p-8 sm:p-12 text-white text-center relative overflow-hidden">
              <div className="absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full -translate-x-1/2 -translate-y-1/2" />
              <div className="absolute bottom-0 right-0 w-40 h-40 bg-white/10 rounded-full translate-x-1/2 translate-y-1/2" />
              
              <div className="relative">
                <div className="text-5xl font-serif text-emerald-200 mb-4">"</div>
                <blockquote className="text-xl sm:text-2xl italic leading-relaxed mb-6">
                  Train up a child in the way he should go: and when he is old, he will not depart from it.
                </blockquote>
                <cite className="text-emerald-200 font-semibold">— Proverbs 22:6</cite>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-xl border border-slate-100 text-center">
              <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate-800 mb-4">
                Share in Our Mission
              </h2>
              <p className="text-slate-600 mb-8 max-w-2xl mx-auto">
                Join us in nurturing the faith of the next generation through biblically-sound resources.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link to="/login">
                  <Button className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-full px-8 py-6">
                    Get Started
                  </Button>
                </Link>
                <Link to="/contact">
                  <Button variant="outline" className="border-slate-300 text-slate-700 hover:bg-slate-50 rounded-full px-8 py-6">
                    Contact Us
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FaithPage;
